import manageSchema from '../model/schema';
import { assertOk, takeData } from '../../misc/api-utils';
import { authFactory, urlApiFactory } from '../model/factory';
import { emptyArray } from '../../misc';

export const PATHNAME = '/api/Modules/BookedTickets';

export const schema = manageSchema
  .pick({
    envJWTToken: true,
    hostApi: true,
    eventId: true
  })
  .required();

// We often get response null for clients that do not have access control configured.
const applyDefault = (data) => (data === null ? emptyArray : data);

export const fetchGet = (params) => async () => {
  const prms = schema.parse(params);

  const url = urlApiFactory(prms);
  url.pathname = PATHNAME;
  url.searchParams.append('eventId', prms.eventId);
  const headers = {
    Authorization: authFactory(prms)
  };

  const req = new Request(url, { headers });
  return fetch(req)
    .then(assertOk)
    .then(takeData)
    .then(applyDefault);
};
